import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { UsersProject } from "./user-management.model";
import { AuthService, IUserInfo, IUserInProject } from '../shared/core/index';
import { HttpService } from '../shared/core/http.service';
import { IUser } from './user.model';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/internal/operators/catchError';

@Injectable()
export class UserService {

    private _userInfo: IUserInfo;
    private userServiceUrl = new URL('user', environment.apiUrl).toString();

    constructor(private _httpService: HttpService, private _authService: AuthService) {
        this._authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }

    addUser(user: IUser): Observable<boolean> {
        var body = JSON.stringify(user);
        return this._httpService.httpPost(this.userServiceUrl+'/addUser', body).pipe(
            tap((p: Response) => {
                return true;
            }),
            catchError(e => {
                console.error('addUser:' + e._body);
                return of<any>(false);
            }));
    }

    patchUser(user: IUser): Observable<boolean> {
        var body = JSON.stringify(user);
        return this._httpService.httpPatch(this.userServiceUrl+'/patchUser', body).pipe(
            tap((p: Response) => true),
            catchError(e => {
                console.error('updateUser:' + e._body);
                return of<any>(false);
            }));
    }

    getUser(email: string): Observable<IUser> {
        return this._httpService.httpGet(this.userServiceUrl + '/GetUser?email=' + email).pipe(
            map(res => res.json()),
            tap(res => {
               return res;
            }, error => console.error(error)));
    }

    extendUser(email: string): Observable<IUser> {
        return this._httpService.httpGet(this.userServiceUrl + '/extend?email=' + email).pipe(
            map(res => {

                return res.json()
            }),
            tap(res => {
               return res;
            }, error => {
                console.error(error._body);
            }));
    }

    resendUser(email: string): Observable<IUser> {
        return this._httpService.httpGet(this.userServiceUrl + '/resend?email=' + email).pipe(
            map(res => {
                return res.json()
            }),
            tap(res => {
               return res;
            }, error => {
                console.error(error._body);
            })
        );
    }
}